import React from "react";
import Avatar from "@/components/avatar/Avatar";
import { Star, Quote } from "lucide-react";

const TESTIMONIALS = [
  {
    id: "parent-7",
    quote: "My 7-year-old asked me what \"profit\" meant after his second day of dog walking. Now he counts what he earned against what his leash cost before every job. I've never seen him this excited about math.",
    name: "Danielle R.", role: "Mom of a 7-year-old · Austin, TX",
    avatar: { look: "boy", skin: 1, hairStyle: "curly", hairColor: 1, outfit: "hoodie", outfitColor: 2, accessory: "none", pet: "dog" },
    kid: "Age 7 · Dog Walker",
  },
  {
    id: "parent-9",
    quote: "My daughter is 9 and fiercely competitive — Riley stealing one of her customers because her price was too high taught her more about fair pricing than any worksheet could. She runs the Craft Maker business like a real shop now.",
    name: "Marcus T.", role: "Dad of a 9-year-old · Portland, OR",
    avatar: { look: "girl", skin: 4, hairStyle: "braids", hairColor: 0, outfit: "apron", outfitColor: 5, accessory: "headband", pet: "lioncub" },
    kid: "Age 9 · Craft Maker",
  },
];

const Stars = () => (
  <div className="flex gap-0.5" aria-label="5 out of 5 stars">
    {[0, 1, 2, 3, 4].map((i) => <Star key={i} className="w-4 h-4 fill-amber-400 text-amber-500" />)}
  </div>
);

const Testimonials = () => (
  <section className="bg-white/70 border-y-4 border-slate-100 py-12" data-testid="landing-testimonials">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-xs font-black uppercase tracking-widest text-amber-600 mb-2">From parents</div>
      <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold text-slate-900 tracking-tight mb-8">What families are saying</h2>
      <div className="grid md:grid-cols-2 gap-5">
        {TESTIMONIALS.map((t, i) => (
          <figure
            key={t.id}
            className="relative bg-white rounded-3xl border-4 border-amber-200 p-6 sm:p-7 card-3d animate-pop-in"
            style={{ animationDelay: `${i * 120}ms` }}
            data-testid={`testimonial-${t.id}`}
          >
            <Quote className="absolute -top-4 left-6 w-9 h-9 text-amber-400 fill-amber-400 bg-white rounded-full p-1.5" />
            <Stars />
            <blockquote className="mt-3 text-base sm:text-lg text-slate-700 font-medium leading-relaxed" data-testid={`testimonial-quote-${t.id}`}>
              “{t.quote}”
            </blockquote>
            <figcaption className="mt-5 flex flex-wrap items-center gap-3">
              <div className="w-14 h-14 rounded-2xl bg-amber-50 border-2 border-amber-200 overflow-hidden flex items-end justify-center shrink-0">
                <Avatar avatar={t.avatar} size={52} className="translate-y-1" testid={`testimonial-avatar-${t.id}`} />
              </div>
              <div className="min-w-0 flex-1">
                <div className="font-heading font-black text-slate-900" data-testid={`testimonial-name-${t.id}`}>{t.name}</div>
                <div className="text-xs font-bold text-slate-500">{t.role}</div>
              </div>
              <span className="w-full sm:w-auto sm:ml-auto text-center shrink-0 bg-emerald-500 text-white text-[10px] font-black uppercase tracking-wider px-3 py-1 rounded-full">{t.kid}</span>
            </figcaption>
          </figure>
        ))}
      </div>
    </div>
  </section>
);

export default Testimonials;
